<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style>
body {
  padding:0;
  margin:0;
  box-sizing: border-box;
  line-height: 1.5;
}
#app {
  font-family: Microsoft YaHei,Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  box-sizing: border-box;
}

/* h2,h3 {
  font-family: PingFang SC B;
} */

/* @font-face {
  font-family: PingFang SC M;
  src: url("./assets/fonts/PINGFANG MEDIUM.TTF");
}

@font-face {
  font-family: PingFang SC B;
  src: url("./assets/fonts/PINGFANG BOLD.TTF");
  font-weight: bold;
} */
</style>
